export type WizardEntrySource = 'dashboard' | 'classic-create' | 'direct'

export type WizardEntryVia = 'drop' | 'pick' | 'link'

export type WizardHandoff = { source: Exclude<WizardEntrySource, 'direct'>; via: WizardEntryVia; files: File[] }

/* far longer than the navigation it bridges; a handoff whose page never mounted must not reach a later visit */
export const HANDOFF_TTL_MS = 30_000

let pending: { handoff: WizardHandoff; at: number } | undefined

/** Files (or just the way in) from outside the wizard, for the wizard page to take when it mounts. */
export const handOffToWizard = (handoff: WizardHandoff, now: number = Date.now()): void => {
  pending = { handoff: { ...handoff, files: [...handoff.files] }, at: now }
}

/** The pending handoff, once: taking it clears it. */
export const takeWizardHandoff = (now: number = Date.now()): WizardHandoff | undefined => {
  const taken = pending
  pending = undefined
  return taken && now - taken.at <= HANDOFF_TTL_MS ? taken.handoff : undefined
}

export const clearWizardHandoff = (): void => {
  pending = undefined
}
